import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-166798aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "condition-operator" };
const _hoisted_2 = ["value"];
const _hoisted_3 = {
    key: 1,
    class: "condition-operator__filter"
};
const _hoisted_4 = ["value"];
const _hoisted_5 = {
    key: 2,
    disabled: ""
};
const _hoisted_6 = { value: "equal" };
import { computed, inject, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConditionOperator',
    setup(__props) {
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { draftCondition, isFilterMode, selectedCriteriaDetails, keepFooterLoadingDuringInteraction } = useAudienceManager(isInclude, groupIndex);
        const isDefaultMode = computed(() => defaultOperators.value.length && !isFilterMode.value);
        const filterDetails = computed(() => selectedCriteriaDetails.value?.filter);
        const filterOperators = computed(() => filterDetails.value?.operators || []);
        const filterType = computed(() => filterDetails.value?.f_type || '');
        const defaultOperators = computed(() => {
            return (selectedCriteriaDetails.value?.operators?.map(operator => ({
                key: operator,
                name: i18n.global.t(`audiences.operators.${operator}`),
            })) || []);
        });
        const getDefaultOperator = () => selectedCriteriaDetails.value?.operators?.[0] || 'equal';
        const getDefaultFilterOperator = () => filterOperators?.value[0] || 'equal';
        const computedOperator = computed({
            get: () => {
                return draftCondition.value?.operator || getDefaultOperator();
            },
            set: newOperator => {
                resetErrorValidation();
                store.dispatch('audienceManager/updateDraftCondition', {
                    groupType,
                    groupIndex,
                    data: { operator: newOperator, referenceObjects: [], value: [] },
                });
            },
        });
        const computedFilterOperator = computed({
            get: () => {
                return draftCondition.value?.f_operator || getDefaultFilterOperator();
            },
            set: newFilterOperator => {
                resetErrorValidation();
                store.dispatch('audienceManager/updateDraftCondition', {
                    groupType,
                    groupIndex,
                    data: { f_operator: newFilterOperator, f_type: filterType?.value, f_value: [] },
                });
            },
        });
        const resetErrorValidation = () => {
            store.commit('audienceManager/SET_CONDITION_VALIDITY', {
                groupType,
                groupIndex,
                isValid: true,
            });
        };
        const initializeDraftOperator = (key) => {
            const isFilter = key === 'f_operator';
            const operator = isFilter ? getDefaultFilterOperator() : getDefaultOperator();
            if (!draftCondition.value || !draftCondition.value?.[key]) {
                store.dispatch('audienceManager/updateDraftCondition', {
                    groupType,
                    groupIndex,
                    data: { [key]: operator, ...(isFilter && { f_type: filterType.value }) },
                });
            }
        };
        watchEffect(() => {
            initializeDraftOperator('operator');
            if (selectedCriteriaDetails.value?.filter) {
                initializeDraftOperator('f_operator');
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isDefaultMode.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedOperator).value = $event)),
                        onFocus: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_unref(keepFooterLoadingDuringInteraction) && _unref(keepFooterLoadingDuringInteraction)(...args))),
                        class: "condition-operator__select"
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultOperators.value, (operator) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: operator.key,
                                value: operator.key
                            }, _toDisplayString(operator.name), 9, _hoisted_2));
                        }), 128))
                    ], 544)), [
                        [_vModelSelect, computedOperator.value]
                    ])
                    : (_unref(isFilterMode))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("span", null, _toDisplayString(filterDetails.value?.name), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((computedFilterOperator).value = $event)),
                                onFocus: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_unref(keepFooterLoadingDuringInteraction) && _unref(keepFooterLoadingDuringInteraction)(...args)))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOperators.value, (operator) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: operator,
                                        value: operator
                                    }, _toDisplayString(_ctx.$t(`audiences.operators.${operator}`)), 9, _hoisted_4));
                                }), 128))
                            ], 544), [
                                [_vModelSelect, computedFilterOperator.value]
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("select", _hoisted_5, [
                            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('audiences.operators.equal')), 1)
                        ]))
            ]));
        };
    }
});
